/**
 * Desktop-Sidebar Collapse-State (schmale Icon-Rail vs. volle Nav mit Labels).
 * localStorage-persistierte Präsentations-Präferenz pro User (kein URL-State —
 * persönlich, kein Deep-Link-Bedarf). Gilt NUR Desktop (≥md); der Mobile-Drawer
 * ist davon unberührt (der klappt immer voll auf).
 *
 * Eingeführt 2026-07-19. Pattern analog `dashboard-recent-view.ts` /
 * `list-density.ts` (defensiver try/catch + Default-Fallback).
 */
const STORAGE_KEY = 'gf-sidebar-collapsed';

/** Defensive read: localStorage kann throwen (disabled / private-mode /
 *  sandboxed iframe). Default `false` (ausgeklappt — Labels sichtbar). */
export function getSidebarCollapsed(): boolean {
  try {
    return globalThis.localStorage?.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

/** Defensive write: setItem kann bei Quota-full throwen. Silent skip. */
export function setSidebarCollapsed(collapsed: boolean): void {
  try {
    globalThis.localStorage?.setItem(STORAGE_KEY, collapsed ? '1' : '0');
  } catch {
    // ignore
  }
}
